import { Button } from '@/global/components/Button'
import { TextField } from '@/global/components/TextField'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/global/components/ui/popover'
import { BookmarkIcon } from 'lucide-react'
import React from 'react'

export default function SalvarFiltro({
    disabled,
    onSalvar,
}: {
    disabled: boolean
    /** Resolve `true` só quando salvou; em erro o popover fica aberto para corrigir o nome. */
    onSalvar: (nome: string) => Promise<boolean>
}) {
    const [aberto, setAberto] = React.useState(false)
    const [nome, setNome] = React.useState('')
    const [isSalvando, setSalvando] = React.useState(false)

    async function salvar() {
        if (isSalvando) return
        setSalvando(true)
        try {
            const isSalvo = await onSalvar(nome.trim())
            if (!isSalvo) return
            setNome('')
            setAberto(false)
        } finally {
            setSalvando(false)
        }
    }

    return (
        <Popover
            open={aberto}
            onOpenChange={isAberto => !isSalvando && setAberto(isAberto)}
        >
            <PopoverTrigger asChild>
                <Button
                    size="small"
                    startIcon={<BookmarkIcon />}
                    disabled={disabled}
                >
                    Salvar filtro
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="flex w-72 gap-2">
                <TextField
                    variant="outlined"
                    size="small"
                    unHelperText
                    autoFocus
                    label="Nome do filtro"
                    maxLength={40}
                    value={nome}
                    className="flex-1"
                    onChange={e => setNome(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && salvar()}
                />
                <Button
                    className="h-12 px-4"
                    onClick={salvar}
                    disabled={isSalvando}
                >
                    Salvar
                </Button>
            </PopoverContent>
        </Popover>
    )
}
